import { Link, Outlet } from '@tanstack/react-router';
import { ArrowLeft, LockKeyhole } from 'lucide-react';

import { t } from '@/shared/i18n';
import { Button } from '@/shared/ui/Button';
import { EmptyState } from '@/shared/ui/EmptyState';
import { useCurrentWorkspace } from '@/shared/workspace/useCurrentWorkspace';

/**
 * Обёртка всего, что внутри /app/w/{slug}.
 *
 * Единственная её задача — ответить на 404 от пространства до того, как
 * дочерние экраны начнут делать свои запросы. Так исключённый участник (или
 * человек с опечаткой в адресе) видит внятное «недоступно» с выходом на
 * список, а не набор вечных скелетонов. На вход его не уводит намеренно:
 * учётная запись жива, доступа нет только сюда.
 */
export function WorkspaceLayout() {
  const { isError } = useCurrentWorkspace();

  if (isError) {
    return (
      <EmptyState
        icon={<LockKeyhole />}
        title={t.workspace.unavailable}
        description={t.workspace.unavailableText}
        action={
          <Button asChild variant="outline" tone="neutral" iconLeft={<ArrowLeft />}>
            <Link to="/app">{t.workspace.toList}</Link>
          </Button>
        }
      />
    );
  }

  return <Outlet />;
}
